module.exports = __webpack_public_path__ + "static/media/in-number-9.439455d6.png";